import React from 'react';
import Table from 'components/Table';
import { Tabs } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
const TabPane = Tabs.TabPane;
const CSVBinsModel = ({ data }) => {
  const columnsData = [
    {
      title: 'BIN',
      render: (value, index) => <React.Fragment key={index}>{value?.bin}</React.Fragment>,
      key: 'bin',
    },
    {
      title: 'Discount Type',
      render: (value, index) => <React.Fragment key={index}>{value?.discount_type}</React.Fragment>,
      key: 'bin',
    },
    {
      title: 'Discount Value',
      render: (value, index) => <React.Fragment key={index}>{value?.discount_value}</React.Fragment>,
      key: 'bin',
    },
    {
      title: 'Discount Limit',
      render: (value, index) => <React.Fragment key={index}>{value?.discount_type?.toLowerCase() === 'percentage' ? value?.discount_limit ?? 'Not Added' : 'Not Required'}</React.Fragment>,
      key: 'bin',
    },
    // {
    //   title: 'Discount Applicable Between',
    //   render: (value, index) => (
    //     <React.Fragment key={index}>
    //       {value?.start_date && value?.end_date ? (
    //         <>
    //           {moment(value?.start_date).utc().format('LL')} - {moment(value?.end_date).utc().format('LL')}{' '}
    //         </>
    //       ) : (
    //         'Not Applied'
    //       )}
    //     </React.Fragment>
    //   ),
    //   key: 'value',
    // },
    {
      title: 'Rule Status',
      render: (value, index) => (
        <React.Fragment key={index}>
          {value?.rule_status == 'true' || value?.rule_status == 'True' || value?.rule_status == 'TRUE' || value?.rule_enabled === true ? 'Enabled' : 'Disabled'}
        </React.Fragment>
      ),
      key: 'bin',
    },
  ];
  return (
    <div style={{ height: '70vh', overflow: 'auto' }}>
      <Tabs style={{ width: '100%' }}>
        {data?.numberOfBINSAdded?.length > 0 && (
          <TabPane
            key='1'
            tab={
              <span id='icon'>
                <span>
                  <CaretRightOutlined />
                </span>
                Configured BINS
              </span>
            }>
            <p className='dis' style={{ color: 'green' }}>
              These bins are configured successfully.
            </p>
            <div className='overflow-x-auto bin-dsicount-table'>
              <Table loading={false} dataSource={data?.numberOfBINSAdded} columns={columnsData} pagingation={{ show: false }} />
            </div>
          </TabPane>
        )}
        {data?.binsDetailsNotFound?.length > 0 && (
          <TabPane
            key='2'
            tab={
              <span id='icon'>
                <span>
                  <CaretRightOutlined />
                </span>
                BINS not Configured
              </span>
            }>
            <p className='dis'>Bins details are not found against these bins.</p>
            <div className='overflow-x-auto bin-dsicount-table'>
              <Table loading={false} dataSource={data?.binsDetailsNotFound} columns={columnsData} pagingation={{ show: false }} />
            </div>
          </TabPane>
        )}
        {data?.duplicateBINSData?.length > 0 && (
          <TabPane
            key='3'
            tab={
              <span id='icon'>
                <span>
                  <CaretRightOutlined />
                </span>
                Duplicates BINS
              </span>
            }>
            <p className='dis' style={{ color: 'red' }}>
              These bins are already configured
            </p>
            <div className='overflow-x-auto bin-dsicount-table'>
              <Table loading={false} dataSource={data?.duplicateBINSData} columns={columnsData} pagingation={{ show: false }} />
            </div>
          </TabPane>
        )}
      </Tabs>
    </div>
  );
};
export default CSVBinsModel;
